import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-default-task',
  templateUrl: './default-task.component.html',
  styleUrls: ['./default-task.component.scss']
})

export class DefaultTaskComponent implements OnInit {
  defaultTaskForm: FormGroup;
  tenantId: any;
  defaultTaskList: any;
  items: FormArray;
  @ViewChild('newTaskName', { static: false }) newTaskName: ElementRef;
  isUpdate: boolean;
  updateIndex: any;

  constructor(
    private formBuilder: FormBuilder,
    private storageConfiguration: StorageConfiguration,
    public parseService: ParseService,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService
  ) {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
  }

  ngOnInit(): void {
    this.createForm();
    this.getDefaultTask();
  }

  /**
   * ? Create form
   */
  createForm(): void {
    this.defaultTaskForm = this.formBuilder.group({
      taskNames: this.formBuilder.array([]),
    });
  }

  /** 
   * ? Create FormArray
   */

  createItem(name?): FormGroup {
    const taskName = name ? name : '';
    return this.formBuilder.group({
      defaulttask: taskName,
    });
  }

  /**
   * ? Add New Default Task
   */

  async addNewDefaultTask(name) {
    const DefaultTask = this.parseService.instance.Object.extend('DefaultTaskList');
    const defaultTaskQuery = new this.parseService.instance.Query(DefaultTask);
    defaultTaskQuery.equalTo('tenantId', this.tenantId);
    const defaultTaskList = await defaultTaskQuery.find();
    let data = defaultTaskList[0];
    let defaultTask = data.get('defaultTasks');
    let defaultTaskDetails = defaultTask.filter(x => x.defaulttask == name.value);
    if (defaultTaskDetails.length > 0) return this.toastr.warning('Default task name is already taken!!');
    if (name.value.length < 4) return this.toastr.warning('Please enter atleast four characters!!');
    this.items = this.defaultTaskForm.get('taskNames') as FormArray;
    this.items.push(this.createItem(name.value));
    await this.updateDefaultTaskList('Create');
    this.newTaskName.nativeElement.value = '';
  }

  /**
   * ? Common Function to create, Update and Delete the default Task 
   */

  async updateDefaultTaskList(type): Promise<void> {
    const DefaultTask = this.parseService.instance.Object.extend('DefaultTaskList');
    const defaultTaskQuery = new this.parseService.instance.Query(DefaultTask);
    defaultTaskQuery.equalTo('tenantId', this.tenantId);
    let defaultTaskList = await defaultTaskQuery.find();
    defaultTaskList = defaultTaskList[0];
    defaultTaskList.set('defaultTasks', this.items.value);
    defaultTaskList.save().then(
      (result) => {
        this.toastr.success('Default Task ' + type + ' successfully');
      }).catch(() => {
        this.toastr.error('Failed to ' + type + ' Default Task');
      });
  }

  /**
   * ? Update the default Task
   */

  async updateDefaultTask(): Promise<any> {
    if (this.newTaskName.nativeElement.value.length < 4) return this.toastr.warning('Please enter atleast four characters!!');
    this.items.at(this.updateIndex).patchValue({ 'defaulttask': this.newTaskName.nativeElement.value });
    await this.updateDefaultTaskList('Update');
    this.isUpdate = false;
    this.newTaskName.nativeElement.value = '';
  }

  /**
   * ? Delete default Task
   */

  async deleteDefaultTask(index: number): Promise<void> {
    this.items.removeAt(index);
    await this.updateDefaultTaskList('Delete');
  }

  /**
   *? Get Default Task Value from Database and Bind in UI
   */

  async getDefaultTask(): Promise<void> {
    const DefaultTask = this.parseService.instance.Object.extend('DefaultTaskList');
    const defaultTaskQuery = new this.parseService.instance.Query(DefaultTask);
    defaultTaskQuery.equalTo('tenantId', this.tenantId);
    const defaultTaskList = await defaultTaskQuery.find();
    const defaultTaskData = JSON.parse(JSON.stringify(defaultTaskList[0]));
    this.defaultTaskList = defaultTaskData.defaultTasks;
    this.items = this.defaultTaskForm.get('taskNames') as FormArray;
    this.defaultTaskList.forEach((item) => {
      const defaultTask = this.formBuilder.group({
        defaulttask: item.defaulttask,
      });
      this.items.push(defaultTask);
    });
  }


  /**
   * ? Patch the selected task in the input field For Update
   */

  patchDefaultTask(index): void {
    this.isUpdate = true;
    this.updateIndex = index;
    this.newTaskName.nativeElement.value = this.defaultTaskForm.get('taskNames').value[index].defaulttask;
  }

}
